export enum NotificationPathEnum {
  HOME = "/notification",
}
